// src/components/ListItemLink.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { listItemButtonStyle, subListItemButtonStyle } from '../styles';


const ListItemLink = ({ icon, primary, to, isSubItem = false, onNavigate }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const active = location.pathname === to;

  const handleClick = () => {
    navigate(to);
    if (onNavigate) {
      onNavigate();
    }
  };

  return (
    <ListItem disablePadding>
      <ListItemButton
        onClick={handleClick}
        sx={isSubItem ? subListItemButtonStyle(active) : listItemButtonStyle(active)}
      >
        {icon && <ListItemIcon>{icon}</ListItemIcon>}
        <ListItemText primary={primary} />
      </ListItemButton>
    </ListItem>
  );
};

export default ListItemLink;